const keyEventListener = ({
    context,
    keys = [],
}) => {
    const eventListeners = {}
    keys.forEach(({ key, action, eventName }) => {
        eventListeners[key] = {}
        const eventHandler = (event) => {
            if (event.key === key) {
                eventListeners[key].actionReturnValue = action(event)
            }
        }
        context.removeEventListener(eventName, eventHandler)
        context.addEventListener(eventName, eventHandler)
        eventListeners[key].removeEventListener = () => {
            context.removeEventListener(eventName, eventHandler)
        }
    })
    return eventListeners
}

export default keyEventListener
